import { Capacitor } from "@capacitor/core";
import { Share } from "@capacitor/share";

const isCapacitor = () => {
  return Capacitor.isNativePlatform();
};
/*
export const copyToClipboard = async (text) => {
  if (navigator?.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
  }
  else {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    textArea.remove();
  }
};
*/
export const universalShare = async ({ title, text, url }) => {
  if (isCapacitor()) {
    try {
      await Share.share({
        title,
        text,
        url,
        dialogTitle: "Share with...",
      });
      return;
    } catch (error) {
      console.warn("[Capacitor Share] Error:", error);
    }
  }

  if (navigator?.share) {
    try {
      await navigator.share({
        title,
        text,
        url,
      });
      return;
    } catch (err) {
      console.warn("[Web Share] Error:", err);
    }
  }

  // try {
  //   await copyToClipboard(url);
  //   alert("Link copied to clipboard!");
  // } catch (err) {
  //   console.error("Failed to copy link: ", err);
  // }
};